import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

function PosgradoMallaSummary({ malla, semestreCount }) {
  return (
    <section className="course-detail__summary">
      <Container fluid>
        <Row className="g-3">
          <Col xs={6} md={3}>
            <div className="course-detail__summary__card">
              <span className="course-detail__summary__label">Vigencia</span>
              <strong className="course-detail__summary__value course-detail__summary__value--accent">
                {malla.Vigencia}
              </strong>
            </div>
          </Col>
          <Col xs={6} md={3}>
            <div className="course-detail__summary__card">
              <span className="course-detail__summary__label">Modalidad</span>
              <strong className="course-detail__summary__value">
                {malla.Modalidad || "—"}
              </strong>
            </div>
          </Col>
          <Col xs={6} md={3}>
            <div className="course-detail__summary__card">
              <span className="course-detail__summary__label">Semestres</span>
              <strong className="course-detail__summary__value">
                {semestreCount}
              </strong>
              {malla.SemanasPorSemestre && (
                <span className="course-detail__summary__meta">
                  {malla.SemanasPorSemestre} semanas c/u
                </span>
              )}
            </div>
          </Col>
          <Col xs={6} md={3}>
            <div className="course-detail__summary__card">
              <span className="course-detail__summary__label">Plan de estudios</span>
              <strong className="course-detail__summary__value">
                {malla.TotalAsignaturas ?? "—"} asignaturas
              </strong>
              <span className="course-detail__summary__meta">
                {malla.TotalCreditos ?? "—"} cr · {malla.TotalHoras ?? "—"} h
              </span>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default PosgradoMallaSummary;
